<template>
  <a-card size="small" title="筛选条件" :bordered="false">
    <a-form-model class="search-form">
      <a-form-model-item>
        <span style="margin-right: 8px">时间:</span>
        <a-range-picker v-model="checkedDate" :default-value="checkedDate" :allow-clear="false" />
      </a-form-model-item>
      <a-form-model-item>
        <span style="margin-right: 8px">项目:</span>
        <a-checkable-tag :checked="selectedProjects.length === 0" @change="selectedProjects = []">全部</a-checkable-tag>
        <template v-for="project in projects">
          <a-checkable-tag :key="project.id" :checked="selectedProjects.indexOf(project.id) > -1" @change="checked => handleChange(project.id, checked)">
            {{ project.name }}
          </a-checkable-tag>
        </template>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment';
import { teamList } from '@/api/system/team';
import { projectList } from '@/api/project/project';

export default {
  name: 'DataFilter',
  data() {
    return {
      checkedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()],
      labelCol: { span: 1 },
      wrapperCol: {},
      checkAll: true,
      indeterminate: false,
      plainOptions: [],
      teams: [],
      selectedTeams: [],
      projects: [],
      selectedProjects: []
    };
  },

  computed: {
    filter() {
      const { checkedDate, selectedProjects } = this;
      return {
        checkedDate,
        selectedProjects
      };
    }
  },

  watch: {
    filter() {
      this.$emit('change', this.checkedDate, this.selectedProjects);
    }
  },
  created() {
    // this.getTeamList();
    this.getProjectList();
  },

  methods: {
    handleChange(project_id, checked) {
      const { selectedProjects } = this;
      const nextSelectedProjects = checked ? [...selectedProjects, project_id] : selectedProjects.filter(t => t !== project_id);
      this.selectedProjects = nextSelectedProjects;
    },
    // 获取团队列表
    getTeamList() {
      teamList({}).then(res => {
        this.teams = res.data.items;
      });
    },
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
